import { useMutation } from '@tanstack/react-query';
import {
  validateDocumentApi,
  exportDocumentApi,
  templateAndProjectFieldsApi,
} from './officeService';
import { notifyError } from '../../../helpers/utils';

export const useOfficeService = () => {
  const validateDocument = useMutation({
    mutationFn: validateDocumentApi,
    onError: (err) => {
      console.error(err);
      notifyError(err.message || 'An error occurred');
    },
  });

  const exportCleanDocument = useMutation({
    mutationFn: exportDocumentApi,
    onError: (err) => {
      console.error(err);
      notifyError(err.message || 'An error occurred');
    },
  });

  const templateAndProjectFields = useMutation({
    mutationFn: (params: { data: FormData; queryParams?: string }) =>
      templateAndProjectFieldsApi(params.data, params.queryParams || ''),
    onError: (err) => {
      console.error(err);
      notifyError(err.message || 'An error occurred');
    },
  });

  return {
    validateDocument,
    exportCleanDocument,
    templateAndProjectFields,
  };
};
